import { BaseInfoType, PosInfoType } from '@kinderlabs-pos/shared-data-type';

import { posAxiosClient } from '@kinderlabs-pos/apis/axios';

export const getPosInfoListAsync =
	(rootUrl: string) =>
	async ({ storeId }: { storeId?: number }) =>
		(
			await posAxiosClient.get<(PosInfoType & BaseInfoType)[]>(`${rootUrl}/store/pos/list`, {
				params: { storeId },
			})
		).data;
